module.exports = __webpack_public_path__ + "static/z_tall_tubzz-265503bfa124e0776fbd0e40031b6385.jpg";